__turbopack_context__.v({
  "delivery": "index-module-scss-module__KY5xFG__delivery",
  "deliveryPay": "index-module-scss-module__KY5xFG__deliveryPay",
  "deliveryPay__title": "index-module-scss-module__KY5xFG__deliveryPay__title",
  "link": "index-module-scss-module__KY5xFG__link",
  "radioButton": "index-module-scss-module__KY5xFG__radioButton",
  "radioGroup": "index-module-scss-module__KY5xFG__radioGroup",
  "titleWrapper": "index-module-scss-module__KY5xFG__titleWrapper",
});
